export const numberOnlyRegex = /^[0-9]*$/;
export const numberWithDotAndCommaRegex = /^-?\d*(?:[.,]?\d*)?$/;
export const withoutNumberRegex = /^[^0-9]+$/;
export const whitespaceRegex = /\s+/;
export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const categoryRegex = /\/|_/g;
export const thousandsRegex = /\B(?=(\d{3})+(?!\d))/g;
export const urlAddressRegex =
  /^(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
export const linkedinRegex = /^linkedin\.com\/in\/[a-zA-Z0-9_-]+$/;
export const instagramRegex = /^https?:\/\/(www\.)?instagram\.com\/[a-zA-Z0-9._]+\/?$/;
export const whatsappRegex = /^https?:\/\/(wa\.me\/|api\.whatsapp\.com\/send\?phone=)(\d{1,15})$/;
export const linkedinProfileRegex =
  /https:\/\/(?:www\.)?linkedin\.com\/(?:in|pub|company)\/[a-zA-Z0-9-]+\/?/;
export const whatsappPrefixRegex = /^08/;
export const htmlElementRegex = /<\/?[^>]+(>|$)/g;
export const decimalRegex = /^(\d)*(\.)?([0-9]{1})?$/;
export const youtubeEmbedShareLinkRegex =
  /(?:https?:\/\/(?:www\.)?)?(?:youtube\.com\/embed\/)([\w-]{11})/i;
export const googleDriveShareLinkRegex =
  /(?:https?:\/\/)?(?:drive\.google\.com\/file\/d\/)([\w-]+)\/preview/i;
export const imageMarkdownRegex = /(?:!\[(.*?)\]\((.*?)\))/g;
export const examImageRegex =
  /!\[(.*?)\]\((https:\/\/rakamin-app\.s3\.ap-southeast-1\.amazonaws\.com.*?)\)/g;
export const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/;
